import type { ComponentPropsWithoutRef } from 'react'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

import Icon from './download.svg'

export const DownloadIcon = (props: ComponentPropsWithoutRef<'svg'>) => {
  return <StyledIcon aria-label="ダウンロード" {...props} />
}

const StyledIcon = styled(Icon)`
  transition: all 0.3s ease-out;
  width: 20px;
  height: 18px;
  fill: ${theme.colors.trialBlue};

  @media screen and (max-width: 1047px) {
    width: 14px;
    height: 13px;
  }
`
